import { MDB_TYPES, SELECTION_TYPES as ST } from "@meddbriefer/scenario-data"

const INTV_PROMPTS = [
    {
        "id": "prompt-wound-location",
        type: MDB_TYPES.DIST_PROMPT,
        selectionType: ST.ONE,
        label: "Where is the wound located?",
        abbrLabel: "Wound location?",
        answers: [
            "answer-wound-location-head",
            "answer-wound-location-neck",
            "answer-wound-location-chest",
            "answer-wound-location-abdomen-pelvis",
            "answer-wound-location-posterior",
            "answer-wound-location-genitalia",
            "answer-wound-location-left-lower-extremity",
            "answer-wound-location-right-lower-extremity",
            "answer-wound-location-left-upper-extremity",
            "answer-wound-location-right-upper-extremity",
            "answer-wound-location-other"
        ]
    },
    {
        "id": "prompt-wound-locations",
        type: MDB_TYPES.DIST_PROMPT,
        selectionType: ST.OOM,
        label: "Where are the wound(s) located?",
        abbrLabel: "Wound location(s)?",
        answers: [
            "answer-wound-locations-head",
            "answer-wound-locations-neck",
            "answer-wound-locations-chest",
            "answer-wound-locations-abdomen-pelvis",
            "answer-wound-locations-posterior",
            "answer-wound-locations-genitalia",
            "answer-wound-locations-left-lower-extremity",
            "answer-wound-locations-right-lower-extremity",
            "answer-wound-locations-left-upper-extremity",
            "answer-wound-locations-right-upper-extremity",
            "answer-wound-locations-other"
        ]
    },


    {
        "id": "prompt-airway-patency-suction-device",
        "interventionID": "intv-airway-patency-technique-suction-airway",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What kind of suction catheter will you use?",
        "abbrLabel": "Suction catheter type?",
        "answers": [
            "answer-airway-patency-suction-yankauer",
            "answer-airway-patency-suction-long-multiuse",
            "answer-airway-patency-suction-other"
        ]
    },

    {
        "id": "prompt-advanced-airway-adjunct-type",
        "interventionID": "intv-advanced-airway-adjunct",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What type of advanced airway adjunct would you use?",
        "abbrLabel": "Which advanced airway?",
        "answers": [
            "answer-alternative-rescue-airway-type-ett",
            "answer-alternative-rescue-airway-type-combitube",
            "answer-alternative-rescue-airway-type-lta",
            "answer-alternative-rescue-airway-type-lma",
            "answer-alternative-rescue-airway-type-igel",
            "answer-alternative-rescue-airway-type-other"
        ]
    }, {
        "id": "prompt-advanced-airway-tube-size",
        "interventionID": "intv-advanced-airway-adjunct",
        "type": MDB_TYPES.PROMPT,
        "selectionType":"one",
        "label": "What tube size for advanced airway?",
        "abbrLabel": "What size?",
        "answers": [
            "answer-alternative-airway-tube-size-7",
            "answer-alternative-airway-tube-size-8",
            "answer-alternative-airway-tube-size-age-div-4-plus-4",
            "answer-alternative-airway-tube-size--age-div-4-plus-4-minus-5",
            "answer-alternative-airway-tube-size-37f",
            "answer-alternative-airway-tube-size-41f",
            "answer-alternative-airway-tube-size-0",
            "answer-alternative-airway-tube-size-1",
            "answer-alternative-airway-tube-size-1-5",
            "answer-alternative-airway-tube-size-2",
            "answer-alternative-airway-tube-size-2-5",
            "answer-alternative-airway-tube-size-3",
            "answer-alternative-airway-tube-size-4",
            "answer-alternative-airway-tube-size-5",
            "answer-alternative-airway-tube-size-6",
            "answer-alternative-airway-tube-size-other"
        ]
    },

    {
        "id": "prompt-orotracheal-intubation-tube-insertion-depth",
        "interventionID": "intv-orotracheal-intubation",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "At what depth would you insert the tube?",
        "abbrLabel": "Tube insertion depth?",
        "answers": [
            "answer-orotracheal-intubation-tube-insertion-depth-21cm",
            "answer-orotracheal-intubation-tube-insertion-depth-23cm",
            "answer-orotracheal-intubation-tube-insertion-depth-3-times-tube-size",
            "answer-orotracheal-intubation-tube-insertion-depth-other"
        ]
    },

    {
        "id": "prompt-nasotracheal-intubation-tube-size",
        "interventionID": "intv-nasotracheal-intubation",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What tube size would you use?",
        "abbrLabel": "Tube size?",
        "answers": [
            "answer-nasotracheal-intubation-tube-size-6-to-6-5",
            "answer-nasotracheal-intubation-tube-size-7-to-7-5",
            "answer-nasotracheal-intubation-tube-size-age-div-4+4-minus1",
            "answer-nasotracheal-intubation-tube-size-age-div-4+4-minus0-5",
            "answer-nasotracheal-intubation-tube-size-0-5-1cm-less-than-oro-size",
            "answer-nasotracheal-intubation-tube-size-other"
        ]
    },

    {
        "id": "prompt-nasal-cannula-flow-rate",
        "interventionID": "intv-supplemental-oxygen-device-nasal-cannula",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What oxygen flow rate would you administer?",
        "abbrLabel": "Oxygen flow rate?",
        "answers": [
            "answer-nasal-cannula-flow-rate-1-6-lpm",
            "answer-nasal-cannula-flow-rate-other"
        ]
    },{
        "id": "prompt-nasal-cannula-target-saturation",
        "interventionID": "intv-supplemental-oxygen-device-nasal-cannula",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What is your target oxygen saturation range?",
        "abbrLabel": "Target O2 saturation?",
        "answers": [
            "answer-nasal-cannula-target-saturation-gt-90-pct",
            "answer-nasal-cannula-target-saturation-other"
        ]
    },

    {
        "id": "prompt-non-rebreather-mask-flow-rate",
        "interventionID": "intv-supplemental-oxygen-device-non-rebreather-mask",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What oxygen flow rate would you administer?",
        "abbrLabel": "Oxygen flow rate?",
        "answers": [
            "answer-non-rebreather-mask-flow-rate-10-15-liters-min",
            "answer-non-rebreather-mask-flow-rate-other"
        ]
    },{
        "id": "prompt-non-rebreather-mask-target-saturation",
        "interventionID": "intv-supplemental-oxygen-device-non-rebreather-mask",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What is your target oxygen saturation range?",
        "abbrLabel": "Target O2 saturation?",
        "answers": [
            "answer-non-rebreather-mask-target-saturation-gt-90-pct",
            "answer-non-rebreather-mask-target-saturation-other"
        ]
    },

    {
        "id": "prompt-bvm-ventilation-rate",
        "interventionID": "intv-ventilation-technique-bag-valve-mask",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "At what rate will you ventilate the patient?",
        "abbrLabel": "",
        "answers": [
            "answer-bvm-ventilation-rate-10-12-bpm",
            "answer-bvm-ventilation-rate-other",
        ]
    }, {
        "id": "prompt-bvm-flow-rate",
        "interventionID": "intv-ventilation-technique-bag-valve-mask",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What flow rate would you administer?",
        "abbrLabel": "Flow rate?",
        "answers": [
            "answer-bvm-flow-rate-15-ltm-or-gt",
            "answer-bvm-flow-rate-other",
        ]
    },{
        "id": "prompt-bvm-target-saturation",
        "interventionID": "intv-ventilation-technique-bag-valve-mask",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What is your target oxygen saturation range?",
        "abbrLabel": "Target O2 saturation?",
        "answers": [
            "answer-bvm-target-saturation-rate-gt-90-pct",
            "answer-bvm-target-saturation-rate-other"
        ]
    },

    {
        "id": "prompt-tourniquet-placement",
        "interventionID": "intv-control-severe-bleeding-technique-tourniquet",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "Where would you place the tourniquet?",
        "abbrLabel": "Tourniquet location?",
        "answers": [
            "answer-tourniquet-placement-close-to-core-far-from-wound",
            "answer-tourniquet-placement-other"
        ]
    },

    {
        "id": "prompt-2nd-tourniquet-placement",
        "interventionID": "intv-control-severe-bleeding-technique-2nd-tourniquet",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "Where would you place the second tourniquet?",
        "abbrLabel": "Tourniquet location?",
        "answers": [
            "answer-2nd-tourniquet-placement-adjacent-to-initial-tourniquet",
            "answer-2nd-tourniquet-placement-other"
        ]
    },

    {
        "id": "prompt-occlusive-dressing-injury-type",
        "interventionID": "intv-occlusive-dressing",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What type of injury are you trying to manage?",
        "abbrLabel": "For what type of injury?",
        "answers": [
            "answer-occulsivive-dressing-injury-type-open-pneumothorax",
            "answer-occulsivive-dressing-injury-type-other"
        ]
    },{
        "id": "prompt-occlusive-dressing-method",
        "interventionID": "intv-occlusive-dressing",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "How would you create a release valve on an occlusive dressing?",
        "abbrLabel": "How would you create a release valve?",
        "answers": [
            "answer-occulsive-dressing-method-leave-one-side-untaped",
            "answer-occulsive-dressing-method-leave-dressing-with-one-way-valve",
            "answer-occulsive-dressing-method-other"
        ]
    },


    {
        "id": "prompt-pleural-decompression-injury-type",
        "interventionID": "intv-pleural-decompression",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What type of injury are you trying to manage?",
        "abbrLabel": "For what type of injury?",
        "answers": [
            "answer-pleural-decompression-injury-type-tension-pneumothorax",
            "answer-pleural-decompression-injury-type-open-pneumothorax",
            "answer-pleural-decompression-injury-type-other"
        ]
    },{
        "id": "prompt-pleural-decompression-needle-placement-side-of-the-body",
        "interventionID": "intv-pleural-decompression",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "On which side of the body would you place the needle?",
        "abbrLabel": "Which side would you place the needle?",
        "answers": [
            "answer-pleural-decompression-needle-placement-side-of-the-body-right",
            "answer-pleural-decompression-needle-placement-side-of-the-body-left"
        ]
    },{
        "id": "prompt-pleural-decompression-needle-placement-anatomical-landmark",
        "interventionID": "intv-pleural-decompression",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "At what anatomical landmark?",
        "abbrLabel": "At what anatomical landmark?",
        "answers": [
            "answer-pleural-decompression-needle-placement-anatomical-landmark-2nd-or-3rd-intercostal-space-mid-clavicular",
            "answer-pleural-decompression-needle-placement-anatomical-landmark-4th-or-5th-intercostal-space-mid-axillary",
            "answer-pleural-decompression-needle-placement-anatomical-landmark-other"
        ]
    },{
        "id": "prompt-pleural-decompression-needle-size",
        "interventionID": "intv-pleural-decompression",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What size needle do you want to use?",
        "abbrLabel": "Needle size?",
        "answers": [
            "answer-pleural-decompression-needle-size-large-bore",
            "answer-pleural-decompression-needle-size-other"
        ]
    },{
        "id": "prompt-pleural-decompression-needle-length",
        "interventionID": "intv-pleural-decompression",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "How long a needle would you use?",
        "abbrLabel": "Needle length?",
        "answers": [
            "answer-pleural-decompression-needle-length-2-inches-or-longer",
            "answer-pleural-decompression-needle-length-other"
        ]
    },

    {
        "id": "prompt-transport-facility-choice",
        "interventionID": "intv-transport",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What type of care facility will you transport the patient to?",
        "abbrLabel": "Type of receiving facility",
        "answers": [
            "answer-transport-facility-choice-level-1-or-2-trauma-center",
            "answer-transport-facility-choice-level-3-or-4-trauma-center",
            "answer-transport-facility-choice-closest",
            "answer-transport-facility-choice-other"
        ]
    },{
        "id": "prompt-transport-method",
        "interventionID": "intv-transport",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "Would you transport this patient by air or ground ambulance?",
        "abbrLabel": "Air or ground ambulance?",
        "answers": [
            "answer-transport-method-ambulance",
            "answer-transport-method-helicopter"
        ]
    },{
        "id": "prompt-transport-lights-siren-decision",
        "interventionID": "intv-transport",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "Would you use lights and sirens with this patient?",
        "abbrLabel": "Lights and sirens?",
        "answers": [
            "answer-transport-lights-sirens-yes",
            "answer-transport-lights-sirens-no"
        ]
    },

    {
        "id": "prompt-splint-type",
        "interventionID": "intv-splint-fractures",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "What type of splint would you use?",
        "abbrLabel": "Type of splint?",
        "answers": [
            "answer-splint-type-board",
            "answer-splint-type-moldable",
            "answer-splint-type-traction",
            "answer-splint-type-pelvic-binder",
            "answer-splint-type-other"
        ]
    },

]
/*
    {
        "id": "",
        "interventionID": "",
        "type": MDB_TYPES.PROMPT,
        "selectionType": ST.ONE,
        "label": "",
        "abbrLabel": "",
        "answers": [
        ]
    },
*/
export default INTV_PROMPTS